import axios from "axios";
import operators from "../../models/operadores/operators";
import operator from "../../models/operadores/operator";
import operaudit from "../../models/operadores/operaudit";
import moment from "moment";
const _3DES = require("nodejs3des");
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getOperators() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/operadores`, { headers }).then(({ data }) =>
      data.map((item) => {
        return operators.fromJson(item);
      })
    );
  }

  getOpertatorId(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/operadores/${id}`, { headers })
      .then(({ data }) => operator.fromJson(data));
  }

  getOpertatorIdAudit(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/operaudit/${id}`, { headers }).then(({ data }) =>
      data.map((item) => {
        return operaudit.fromJson(item);
      })
    );
  }

  getOperatorsTablas() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/operaudit/tablas`, { headers });
  }

  addOperator(payload) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    if (payload.hasOwnProperty("fecBaja")) {
      payload.fecBaja =
        moment.utc(payload.fecBaja).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    return axios.post(`${url}/operadores`, payload, { headers });
  }

  editOperator(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const dkey = process.env.VUE_APP_DKEY.replace(/\\/g, "");

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = { ...data };

    if (data.hasOwnProperty("fecBaja")) {
      payload.fecBaja =
        moment.utc(data.fecBaja).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    delete payload.id;
    return axios
      .patch(`${url}/operadores/${data.id}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteOperator(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/operadores/${id}`, { headers });
  }
  ////relaciones/////

  //Operador-Empleado
  addEmployeeToOperator(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.post(`${url}/operadores/emps`, data, { headers });
  }

  deleteEmployeeToOperator(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/operadores/emp/${data.operId}&${data.empId}`, {
      headers,
    });
  }

  //Operador-Grupo
  addGroupToOperator(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.post(`${url}/operadores/grps`, data, { headers });
  }

  deleteGroupToOperator(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/operadores/grp/${data.operId}&${data.grupoId}`,
      { headers }
    );
  }
  //Operadores-Unidades de Negocios
  addBusinessUnitsToOperator(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      operId: data.operId,
      unNegocioId: data.unNegocioId,
      fecDesde: data.fecAlta,
      def: data.def,
    };

    if (data.hasOwnProperty("fecBaja")) {
      payload.fecHasta =
        moment.utc(data.fecBaja).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    return axios.post(`${url}/operadores/unnegocio`, payload, { headers });
  }

  editBusinessUnitsToOperator(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {};

    if ("def" in data) {
      payload.def = data.def;
    }

    if (data.dateStartInput !== undefined) {
      payload.fecDesde = data.dateStartInput + "T00:00:00.000Z";
    }

    if (data.hasOwnProperty("dateEndInput")) {
      payload.fecHasta =
        moment.utc(data.dateEndInput).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }

    return axios
      .patch(
        `${url}/operadores/unnegocio/${data.operId}&${data.unNegocioId}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteBusinessUnitsToOperator(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/operadores/unnegocio/${data.operId}&${data.id}`,
      { headers }
    );
  }

  //Operador-Rol
  addRoleToOperator(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      operId: data.operId,
      rolId: Number(data.rolId),
    };

    return axios.post(`${url}/operadores/rol`, payload, { headers });
  }

  deleteRoleToOperator(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/operadores/rol/${data.operId}&${data.rolId}`, {
      headers,
    });
  }

  //AUDITORIA
  addAudit(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      tablas: data.tablas,
      operId: data.operId,
      fecDesde: data.fecDesde + "T00:00:00.000Z",
    };
    if (data.hasOwnProperty("fecHasta")) {
      payload.fecHasta =
        moment.utc(data.fecHasta).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    return axios.post(`${url}/operaudit`, payload, { headers });
  }

  deleteAudit(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      operId: data.operId,
      tabla: data.tabla,
      fecDesde:
        moment(data.dateStart, "DD-MM-YYYY").format("YYYY-MM-DD") +
        "T00:00:00.000Z",
    };
    return axios.delete(
      `${url}/operaudit/${payload.operId}&${payload.tabla}&${payload.fecDesde}`,
      { headers }
    );
  }

  editAudit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {};
    if (data.hasOwnProperty("dateStart")) {
      data.dateStart = data.dateStart + "T00:00:00.000Z";
      if (data.hasOwnProperty("fecDesdeNew")) {
        payload.fecDesde = data.fecDesdeNew + "T00:00:00.000Z";
      }
    }
    if (data.hasOwnProperty("fecHastaNew")) {
      payload.fecHasta =
        moment.utc(data.fecHastaNew).format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    if (data.hasOwnProperty("haNoEx")) {
      payload.haNoEx = data.haNoEx;
    }
    return axios
      .patch(
        `${url}/operaudit/${data.operId}&${data.tabla}&${data.dateStart}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }
  async getGeneratePassword() {
    try {
      let token = localStorage.getItem("token");
      const url = this.config.apiUrl;
      const dkey = process.env.VUE_APP_DKEY.replace(/\\/g, "");
      let headers = {
        Authorization: `Bearer ${token}`,
      };
      let response = await axios.get(`${url}/password`, { headers });
      let password = _3DES.decrypt(dkey, response.data);
      return password;
    } catch (error) {
      console.error("Error generating password:", error);
      throw error;
    }
  }
  changepass(id, newPassword, sendMail) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const dkey = process.env.VUE_APP_DKEY.replace(/\\/g, "");
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      newPassword: _3DES.encrypt(dkey, newPassword),
      sendMail: sendMail,
    };
    return axios
      .patch(`${url}/changepass/${id}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }
}

export default service;
